export default __webpack_public_path__ + "static/media/report-screen1-bg.4ffeddd5.svg";